import React, { Component } from 'react';
import {
  Alert,
  ButtonGroup,
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Table } from 'reactstrap';

class PaymentModal extends Component {
  state = {
    activeTab: 'one-time'
  }

  handleActiveTab = (tab) => {
    this.setState({ activeTab: tab });
  }

  OneTimePayment = () => {
    return (
      <div>
        <Table className="mb-0" size="sm" responsive striped borderless>
          <tbody>
            <tr>
              <th scope="row" className="pl-3">Current Due</th>
              <td className="text-right pr-3">$300.00</td>
            </tr>
            <tr>
              <th scope="row" className="pl-3">Past Due</th>
              <td className="text-right pr-3">$0</td>
            </tr>
            <tr>
              <th scope="row" className="pl-3">Fees</th>
              <td className="text-right pr-3">$0</td>
            </tr>
            <tr>
              <th scope="row" className="pl-3"><strong>Total Due</strong> by September 19, 2019</th>
              <td className="text-right pr-3"><strong>$300.00</strong></td>
            </tr>
          </tbody>
        </Table>
        <ModalBody>
          <Alert color="danger" className="text-center">
            <strong>There was an problem processing your payment.</strong><br />
            Please try again or call us at 800-994-6177
          </Alert>
          <FormGroup>
            <Label for="paymentAccount">Pay From Account</Label>
            <Input
              type="select"
              name="payment-account"
              id="paymentAccount"
              defaultValue="paymentAccount1"
            >
              <option value="paymentAccount1">Chase Bank ending 1234</option>
              <option value="newAccount">Add New Account</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="paymentDate">Payment Date</Label>
            <Input
              type="date"
              name="payment-date"
              id="paymentDate"
            />
          </FormGroup>
          <FormGroup className="mb-1">
            <Label for="paymentAmount">Payment Amount</Label>
            <Input
              type="select"
              name="payment-amount"
              id="paymentAmount"
              defaultValue="amountCurrent"
            >
              <option value="amountCurrent">Current Due - $300.00</option>
              <option value="amountPrincipal">Principal Only - $223.44</option>
              <option value="amountOther">Other Amount</option>
            </Input>
          </FormGroup>
          <small className="text-center d-block mt-2 mb-1">By clicking "Make Payment", I authorize a payment as designated above.</small>
          <Button color="primary" className="w-100 mt-1 mb-2" disabled>Make Payment</Button>
          <a href="/" className="d-block text-center">How will my payment be applied?</a>
        </ModalBody>
      </div>
    );
  }

  RecurringPayment = () => {
    return (
      <div>
        <Table className="mb-0" size="sm" responsive striped borderless>
          <tbody>
            <tr>
              <th scope="row" className="pl-3">Frequency</th>
              <td className="text-right pr-3">Monthly (Every 8th)</td>
            </tr>
            <tr>
              <th scope="row" className="pl-3">Next Date</th>
              <td className="text-right pr-3">September 9, 2019</td>
            </tr>
            <tr>
              <th scope="row" className="pl-3">Pay From</th>
              <td className="text-right pr-3"><strong>Chase Bank</strong> ending 1234</td>
            </tr>
            <tr>
              <th scope="row" className="pl-3">Pay Amount</th>
              <td className="text-right pr-3"><strong>$300.00</strong></td>
            </tr>
          </tbody>
        </Table>
        <ModalBody>
          <Row>
            <Col>
              <Button size="sm" className="w-100">Edit Payment</Button>
            </Col>
            <Col>
              <Button size="sm" className="w-100">Cancel Payments</Button>
            </Col>
          </Row>
        </ModalBody>
      </div>
    );
  }

  PayoffPayment = () => {
    return (
      <div>
        <ModalBody className="pt-0">
          <FormGroup>
            <Label for="paymentAccount2">Pay From Account</Label>
            <Input
              type="select"
              name="payment-account2"
              id="paymentAccount2"
              defaultValue="paymentAccount1"
            >
              <option value="paymentAccount1">Chase Bank ending 1234</option>
              <option value="newAccount">Add New Account</option>
            </Input>
          </FormGroup>
          <FormGroup className="mb-1">
            <Label for="payoffDate">Payoff Date & Amount</Label>
            <Input
              type="select"
              name="payoff-date"
              id="payoffDate"
            >
              <option value="">Choose Date...</option>
              <option value="date1">September 21, 2019 – $2,484.12</option>
              <option value="date1">September 22, 2019 – $2,484.24</option>
              <option value="date1">September 23, 2019 – $2,484.36</option>
              <option value="date1">September 24, 2019 – $2,484.48</option>
              <option value="date1">September 25, 2019 – $2,484.60</option>
              <option value="date1">September 26, 2019 – $2,484.72</option>
            </Input>
          </FormGroup>
          <Button color="primary" className="w-100 mt-1" disabled>Review Payoff</Button>
        </ModalBody>
      </div>
    );
  }

  render() {
    const { activeTab } = this.state;

    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} size="md" className="align-top">

        <ModalHeader className="no-border" toggle={this.props.toggle}>Make A Payment</ModalHeader>
        <ButtonGroup size="sm" className="d-flex ml-3 mr-3 mb-3">
          <Button color="primary" onClick={() => this.handleActiveTab('one-time')} active={activeTab === 'one-time' && true}>One-Time</Button>
          <Button color="primary" onClick={() => this.handleActiveTab('autopay')} active={activeTab === 'autopay' && true}>Autopay</Button>
          <Button color="primary" onClick={() => this.handleActiveTab('payoff')} active={activeTab === 'payoff' && true}>Payoff</Button>
        </ButtonGroup>

        { activeTab === 'one-time' && this.OneTimePayment() }
        { activeTab === 'autopay' && this.RecurringPayment() }
        { activeTab === 'payoff' && this.PayoffPayment() }


      </Modal>
    );
  }
}

export default PaymentModal;
